import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByCompany() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by Company"
      subtitle="Active fuel access registrations grouped by the company of the user's retail outlet."
      dimension="company"
      dropdownLabel="Company"
      dropdownPlaceholder="All companies"
      dropdownApiPath="/master/companies"
    />
  );
}
